"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolMap = void 0;
/**
 * 兼容了_连接和/连接的SymbolMap
 */
class SymbolMap extends Map {
    static compatibleKey(key) {
        return key.replace("_", "/");
    }
    get(key) {
        var _a;
        return (_a = super.get(key)) !== null && _a !== void 0 ? _a : super.get(SymbolMap.compatibleKey(key));
    }
    set(key, value) {
        return super.set(SymbolMap.compatibleKey(key), value);
    }
    has(key) {
        return super.has(SymbolMap.compatibleKey(key));
    }
    delete(key) {
        return super.delete(SymbolMap.compatibleKey(key));
    }
    getSymbol(base, quote) {
        return this.get(`${base}/${quote}`);
    }
}
exports.SymbolMap = SymbolMap;
